import styled from 'styled-components';

// Toast de feedback
export const Toast = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 18px;
  border-radius: 10px;
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  z-index: 1200;

  &.success { background: #34574A; }
  &.error { background: #c62828; }
`;

/* Estilos globais do formulário de agente (criar/editar) */
export const AgentFormWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 18px 20px;
  align-items: flex-start;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }

  .avatar-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    position: relative;
  }
  .avatar-circle {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: #34574A;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.2rem;
    font-weight: 700;
    overflow: hidden;
    box-shadow: 0 6px 14px rgba(0,0,0,0.12);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .camera-button {
    position: absolute;
    bottom: -6px;
    right: 6px;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 50%;
    border: 2px solid #e2e8f0;
    color: #34574A;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s;
    box-shadow: 0 6px 14px rgba(0,0,0,0.08);

    svg { width: 18px; height: 18px; display: block; }
    input {
      position: absolute;
      inset: 0;
      opacity: 0;
      cursor: pointer;
      display: none !important;
    }

    &:hover { background: #f1f5f9; border-color: #cbd5e1; }
  }
  .remove-image-button {
    position: absolute;
    top: -6px;
    right: 6px;
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #ef4444;
    border: 2px solid #fff;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    transition: background 0.2s, transform 0.2s;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
    
    svg { width: 16px; height: 16px; display: block; }
    
    &:hover {
      background: #dc2626;
      transform: scale(1.05);
    }
    
    &:active {
      transform: scale(0.95);
    }
  }
  .fields {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 14px 16px;
    margin-top: 4px;
  }
`;

export const PageContainer = styled.div`
  padding: 40px;
  min-height: 100vh;
`;

export const Header = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    font-size: 1.5rem;
    color: #333;
    margin: 0;
  }
`;

export const AddButton = styled.button`
  padding: 12px 24px;
  background: #34574A;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.3s ease;

  &:hover {
    background: #2a4539;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const FiltersContainer = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
`;

export const SearchInput = styled.input`
  flex: 1;
  min-width: 200px;
  padding: 12px 16px;
  border: 2px solid #eee;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: all 0.3s ease;

  &:focus {
    border-color: #34574A;
    outline: none;
  }
`;

export const FilterSelect = styled.select`
  padding: 12px 16px;
  border: 2px solid #eee;
  border-radius: 8px;
  font-size: 0.875rem;
  background: white;
  cursor: pointer;
  min-width: 150px;

  &:focus {
    border-color: #34574A;
    outline: none;
  }
`;

export const TableContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 16px;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  th {
    background: #f8f9fa;
    color: #666;
    font-weight: 500;
    font-size: 0.875rem;
  }

  td {
    color: #333;
    font-size: 0.875rem;
  }

  tbody tr {
    transition: background 0.3s ease;

    &:hover {
      background: #f8f9fa;
    }
  }
`;

export const AgentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AgentAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ color, $photoUrl }) => $photoUrl ? `url(${$photoUrl}) center/cover no-repeat, ${color || '#34574A'}` : (color || '#34574A')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  flex-shrink: 0;
  overflow: hidden;
  text-transform: uppercase;
`;

export const AgentDetails = styled.div`
  .name {
    font-weight: 500;
    color: #333;
    margin-bottom: 4px;
  }

  .role {
    font-size: 0.75rem;
    color: #666;
  }
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  
  &.active {
    background: #e6f4ea;
    color: #1e7e34;
  }
  
  &.inactive {
    background: #ffebee;
    color: #c62828;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionButton = styled.button`
  padding: 8px;
  border-radius: 6px;
  background: ${props => props.$variant === 'danger' ? '#ffebee' : props.$variant === 'primary' ? '#34574A' : 'white'};
  color: ${props => props.$variant === 'danger' ? '#c62828' : props.$variant === 'primary' ? 'white' : '#666'};
  border: ${props => props.$variant === 'primary' || props.$variant === 'danger' ? 'none' : '1px solid #eee'};
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background: ${props => props.$variant === 'danger' ? '#ffcdd2' : props.$variant === 'primary' ? '#2a4539' : '#f8f9fa'};
  }
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
  margin-right: 8px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 20px;

    &:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 2px;
      bottom: 2px;
      background-color: white;
      transition: .4s;
      border-radius: 50%;
    }
  }

  input:checked + .slider {
    background-color: #34574A;
  }

  input:checked + .slider:before {
    transform: translateX(16px);
  }
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 48px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  h3 {
    font-size: 1.25rem;
    color: #333;
    margin-bottom: 8px;
  }

  p {
    color: #666;
    margin-bottom: 24px;
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const DeleteModal = styled(Modal)`
  .modal-content {
    background: #fff;
    padding: 24px 32px 20px 32px;
    border-radius: 14px;
    min-width: 270px;
    max-width: 350px;
    box-shadow: 0 4px 16px rgba(52,87,74,0.10);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    position: relative;
  }
  h3 {
    font-size: 1.18rem;
    color: #232b36;
    font-weight: 700;
    margin-bottom: 0px;
    text-align: center;
  }
  p {
    color: #232b36;
    text-align: center;
    font-size: 1rem;
    margin-bottom: 0;
  }
  .delete-actions {
    display: flex;
    gap: 12px;
    margin-top: 12px;
    justify-content: center;
    width: 100%;
  }
  .btn-cancel {
    background: #fff;
    border: 1.5px solid #e7e7e7;
    color: #888;
    border-radius: 7px;
    padding: 8px 22px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background .14s, color .14s;
    &:hover { background: #f6f6f6; color: #ba824f; }
  }
  .btn-delete {
    background: #ba824f;
    border: none;
    color: #fff;
    border-radius: 7px;
    padding: 8px 22px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background .14s;
    &:hover { background: #a46d3f; }
  }
`;

export const PermModal = styled(Modal)`
  .modal-content {
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    min-width: 400px;
    max-width: 500px;
  }
  h3 {
    margin-bottom: 16px;
    color: #34574A;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 32px 0 0 0;
`;

export const PageButton = styled.button`
  background: ${({ $active }) => $active ? '#34574A' : '#fff'};
  color: ${({ $active }) => $active ? '#fff' : '#34574A'};
  border: 1.5px solid #e7e7e7;
  border-radius: 8px;
  font-weight: 500;
  font-size: 1.08rem;
  padding: 7px 18px;
  cursor: pointer;
  transition: background .14s, color .14s;
  outline: none;
  &:hover {
    background: ${({ $active }) => $active ? '#34574A' : '#f2f4f3'};
    color: #34574A;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const EditModal = styled(Modal)`
  .modal-content {
    background: #fff;
    padding: 36px 38px 30px 38px;
    border-radius: 16px;
    min-width: 680px;
    max-width: 980px;
    width: 100%;
    box-shadow: 0 8px 32px rgba(52,87,74,0.16);
    display: flex;
    flex-direction: column;
    gap: 18px;
    position: relative;
    align-items: center;
  }
  .agent-form {
    width: 100%;
    display: grid;
    grid-template-columns: 180px 1fr;
    gap: 18px 20px;
    align-items: flex-start;

    @media (max-width: 760px) {
      grid-template-columns: 1fr;
    }
  }
  .avatar-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    position: relative;
  }
  .avatar-circle {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: #34574A;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.2rem;
    font-weight: 700;
    overflow: hidden;
    box-shadow: 0 6px 14px rgba(0,0,0,0.12);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .camera-button {
    position: absolute;
    bottom: -6px;
    right: 6px;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 50%;
    border: 2px solid #e2e8f0;
    color: #34574A;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s;
    box-shadow: 0 6px 14px rgba(0,0,0,0.08);

    svg { width: 18px; height: 18px; display: block; }
    input {
      position: absolute;
      inset: 0;
      opacity: 0;
      cursor: pointer;
      display: none !important;
    }

    &:hover { background: #f1f5f9; border-color: #cbd5e1; }
  }
  .close-btn {
    position: absolute; top: 18px; right: 22px; background: none; border: none;
    font-size: 1.7rem; color: #aaa; cursor: pointer;
    &:hover { color: #ba824f; }
  }
  .edit-avatar {
    font-size: 3.4rem;
    color: #34574A;
    margin-bottom: 4px;
  }
  h3 {
    font-size: 1.35rem;
    color: #34574A;
    font-weight: 700;
    margin-bottom: 0px;
    text-align: center;
  }
  .fields {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 14px 16px;
    margin-top: 4px;
  }
  label {
    font-size: 0.98rem;
    color: #34574A;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  input, select {
    border: 2px solid #e7e7e7;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 1rem;
    margin-top: 2px;
    transition: border .18s;
    &:focus { border-color: #34574A; outline: none; }
  }
  .switch-field {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .edit-actions {
    display: flex;
    gap: 16px;
    margin-top: 18px;
    justify-content: flex-end;
    width: 100%;
  }
`;

export const NewAgentModal = styled(Modal)`
  .modal-content {
    background: #fff;
    padding: 36px 38px 30px 38px;
    border-radius: 16px;
    min-width: 680px;
    max-width: 980px;
    max-height: 90vh;
    box-shadow: 0 8px 32px rgba(52,87,74,0.16);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: center;
    gap: 14px;
    position: relative;
  }
  .agent-form {
    width: 100%;
    display: grid;
    grid-template-columns: 180px 1fr;
    gap: 18px 20px;
    align-items: flex-start;

    @media (max-width: 760px) {
      grid-template-columns: 1fr;
    }
  }
  .avatar-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    position: relative;
  }
  .avatar-circle {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: #34574A;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.2rem;
    font-weight: 700;
    overflow: hidden;
    box-shadow: 0 6px 14px rgba(0,0,0,0.12);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .camera-button {
    position: absolute;
    bottom: -6px;
    right: 6px;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 50%;
    border: 2px solid #e2e8f0;
    color: #34574A;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s;
    box-shadow: 0 6px 14px rgba(0,0,0,0.08);

    svg { width: 18px; height: 18px; display: block; }
    input {
      position: absolute;
      inset: 0;
      opacity: 0;
      cursor: pointer;
    }

    &:hover { background: #f1f5f9; border-color: #cbd5e1; }
  }
  .close-btn {
    position: absolute; top: 18px; right: 22px; background: none; border: none;
    font-size: 1.7rem; color: #aaa; cursor: pointer;
    &:hover { color: #ba824f; }
  }
  .edit-avatar {
    font-size: 3.4rem;
    color: #34574A;
    margin-bottom: 4px;
  }
  h3 {
    font-size: 1.35rem;
    color: #34574A;
    font-weight: 700;
    margin-bottom: 0px;
    text-align: center;
    content: 'Novo Agente';
  }
  .fields {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 14px 16px;
    margin-top: 4px;
  }
  label {
    font-size: 0.97rem;
    color: #34574A;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  input, select {
    border: 2px solid #e7e7e7;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 1rem;
    margin-top: 2px;
    transition: border .18s;
    &:focus { border-color: #34574A; outline: none; }
  }
  select {
    color: #34574A;
    background: #fff;
  }
  .switch-field {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .new-actions {
    display: flex;
    gap: 12px;
    margin-top: 14px;

    .btn-primary {
      flex: 1;
      padding: 12px 16px;
      border-radius: 10px;
      font-weight: 700;
      font-size: 0.95rem;
      cursor: pointer;
      transition: all 0.2s ease;
      border: none;
      background: #34574A;
      color: #fff;
      box-shadow: 0 8px 18px rgba(52, 87, 74, 0.18);
    }

    .btn-primary:hover { filter: brightness(.95); }

    .btn-secondary {
      flex: 1;
      padding: 12px 16px;
      border-radius: 10px;
      font-weight: 700;
      font-size: 0.95rem;
      cursor: pointer;
      transition: all 0.2s ease;
      border: 1px solid #e2e8f0;
      background: #f8fafc;
      color: #0f172a;
    }

    .btn-secondary:hover { background: #eef2f7; }
  }
`;

export const CreateUserModal = styled(Modal)`
  .modal-content {
    background: #fff;
    padding: 28px 32px;
    border-radius: 16px;
    width: 100%;
    max-width: 920px;
    max-height: 90vh;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;
    animation: fadeIn 0.3s ease;
    overflow-y: auto;

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;

    h3 {
      font-size: 1.5rem;
      color: #34574A;
      margin: 0;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 1.5rem;
      color: #aaa;
      cursor: pointer;
      transition: color 0.2s ease;

      &:hover {
        color: #ba824f;
      }
    }
  }

  .fields {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 16px 20px;

    label {
      font-size: 0.95rem;
      color: #34574A;
      font-weight: 500;
      display: flex;
      flex-direction: column;
      gap: 8px;

      input, select {
        border: 2px solid #eee;
        border-radius: 8px;
        padding: 10px 12px;
        font-size: 1rem;
        transition: border 0.2s ease;

        &:focus {
          border-color: #34574A;
          outline: none;
        }
      }
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 16px;

    button {
      padding: 10px 20px;
      border-radius: 8px;
      font-size: 1rem;
      font-weight: 500;
      cursor: pointer;
      transition: background 0.2s ease, color 0.2s ease;

      &.btn-cancel {
        background: #fff;
        border: 1.5px solid #eee;
        color: #888;

        &:hover {
          background: #f6f6f6;
          color: #ba824f;
        }
      }

      &.btn-save {
        background: #34574A;
        color: #fff;
        border: none;

        &:hover {
          background: #2a4539;
        }

        &:disabled {
          background: #ccc;
          cursor: not-allowed;
        }
      }
    }
  }
`;
